import React, { useEffect, useState } from 'react'
import stylePixel from '../stylesPixelNav.module.sass'
import Slider from 'react-slick'

import { repareTitleSEO } from 'functions/repareDataService'
import {  NO_IMAGE } from "constants/general"
import { usePixel } from '../usePixel'
import CurrencyFormat from 'react-currency-format'


export function CardPixel(props){
    const {
        id,
        images,
        title,
        sale_price,
        discount,
        features,
        cs_months
    } = props

    const [mensualidad, setMensaulidad] = useState()
    const domain = window.location.origin
    
    useEffect(()=>{
        if(cs_months?.length >= 1){
            setMensaulidad(cs_months[cs_months.length - 1]?.price)
        }
    },[cs_months])

    const [fullF, setFullF] = useState(false)
    useEffect(()=>{
        if(features?.fulfillment || features?.super_express){
            setFullF(true)
        }
    },[features])


    return(
        <div key={id} className={stylePixel?.myCard}>
            <div key={id} className={stylePixel?.cardNav}>
                <a href={`${domain}/producto/${id}/${repareTitleSEO(title)}`} >
                    <div className={stylePixel?.img}>
                        {images?.length >= 1 
                            ?
                                <img src={images[0]?.thumbnail.indexOf('?') >= 0 ? images[0]?.thumbnail+"&scale=350" : images[0]?.thumbnail+"?scale=350"} alt={repareTitleSEO(title)} />
                                
                            : 
                                <img src={NO_IMAGE} alt={repareTitleSEO(title)} />
                        }
                    </div>
                </a>
                <div className={stylePixel?.description}>
                    <div className={stylePixel?.text}>{title}</div>
                    {fullF
                        ? <div className={fullF ? stylePixel?.fullFilment : null}></div>
                        : null
                    }
                    <div className={stylePixel?.price}>
                        <CurrencyFormat
                            value={Number(sale_price)}
                            displayType={'text'}
                            decimalScale={0}
                            FixedDecimalScale={true}
                            thousandSeparator={true} prefix={'$'} renderText={value => <>{value} MXN  
                                {discount >= 10
                                    ? <div className={stylePixel?.discount}>{discount}%</div>
                                    : null
                                }
                            </>} 
                        />    
                    </div>
                    {mensualidad
                        ?
                            <div className={stylePixel?.mensualidad}>
                                <CurrencyFormat
                                    value={Number(mensualidad)}
                                    displayType={'text'}
                                    decimalScale={0}
                                    FixedDecimalScale={true}
                                    thousandSeparator={true} prefix={'$'} renderText={value => <>{value} <p>mensuales con</p>
                                    <div className={stylePixel?.icoCCS}></div>
                                    </>} 
                                />    
                            </div>
                        : null
                    }
                </div>
            </div>
        </div>
    )
}

export default function PixelDesktop(props) {
    const {
        typeView
    } = props
    const {
        initPixel,
        productsDesktop,
        productsCount,
        showPixel
    } = usePixel({section: 'Home'})

    useEffect(()=>{
        initPixel(true)
    },[])

    const settings = {
        dots: false,
        autoplay: false,
        infinite: false,
        centerMode: false,
        swipe: true,
        touchMove: true,
        slidesToShow: 5,
        adaptiveHeight: true,
        speed: 700,
        responsive: [
            {
                breakpoint: 1820,
                settings: {
                    autoplay: false,
                    infinite: false,
                    centerMode: false,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 4,
                    speed: 700,
                }
            },
            {
                breakpoint: 1550,
                settings: {
                    autoplay: false,
                    infinite: false,
                    centerMode: false,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 3,
                    speed: 700,
                }
            },
            {
                breakpoint: 1250,
                settings: {
                    autoplay: false,
                    infinite: false,
                    centerMode: false,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 2,
                    speed: 700,
                }
            },
            {
                breakpoint: 970,
                settings: {
                    autoplay: false,
                    infinite: false,
                    centerMode: true,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    speed: 700,
                }
            },
            {
                breakpoint: 780,
                settings: {
                    autoplay: false,
                    infinite: false,
                    centerMode: false,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 2,
                    speed: 700,
                }
            },
            {
                breakpoint: 580,
                settings: {
                    autoplay: false,
                    infinite: false,
                    centerMode: true,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    speed: 700,
                }
            }
        ]
    };

    return (
        showPixel
            ?
                productsCount >= 5
                    ?
                        <div className={stylePixel?.moduleCarruselHome}>
                            <div className={stylePixel?.containerHistorial}>
                                <div className={stylePixel?.containerSliderNav}>
                                    <div className={`${stylePixel?.containerCards} ${stylePixel?.contRecomendation}`}>
                                        <div className={stylePixel?.h2}>
                                            <h2>Últimos vistos</h2>
                                        </div>

                                        {typeView === "desktop"
                                            ?
                                                <Slider {...settings}>
                                                    {productsDesktop?.map(({ id, images, title, sale_price, discount, features, cs_months}, index) =>
                                                        <CardPixel
                                                            key={id}
                                                            id={id}
                                                            images={images}
                                                            title={title}
                                                            sale_price={sale_price}
                                                            discount={discount}
                                                            features={features}
                                                            cs_months={cs_months}
                                                        />
                                                    )}
                                                </Slider>
                                            :
                                                <div className={stylePixel?.moduleScroll}>
                                                    {productsDesktop?.map(({ id, images, title, sale_price, discount, features, cs_months}, index) =>
                                                        <CardPixel
                                                            key={id}
                                                            id={id}
                                                            images={images}
                                                            title={title}
                                                            sale_price={sale_price}
                                                            discount={discount}
                                                            features={features}
                                                            cs_months={cs_months}
                                                        />
                                                    )}
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    : null 
            : null 
    )
}